import generalStyles from '@/components/General/Styles.module.scss';
import { MultiSelectColumnFilter } from '../General/MultiSelectColumnFilter';
import { FILTER_TYPES } from '../General/DataTable';
import { DateRangeColumnFilter } from '../General/DateRangeColumnFilter';
import { Link } from 'react-router-dom';

export const COLUMNS = [
    {
        Header: 'First Name',
        accessor: 'firstName',
        className: generalStyles.tableCell,
        Filter: MultiSelectColumnFilter,
        filter: FILTER_TYPES.multiple,
    },
    {
        Header: 'Last Name',
        accessor: 'lastName',
        className: generalStyles.tableCell,
        Filter: MultiSelectColumnFilter,
        filter: FILTER_TYPES.multiple,
    },
    {
        Header: 'User Email',
        accessor: 'userEmail',
        className: generalStyles.tableCell,
        Filter: MultiSelectColumnFilter,
        filter: FILTER_TYPES.multiple,
    },
    {
        Header: 'Company Name',
        accessor: 'companyName',
        className: generalStyles.tableCell,
        Filter: MultiSelectColumnFilter,
        filter: FILTER_TYPES.multiple,
        Cell: ({ row, value }) => (
            <Link className={generalStyles.link} to={`/newcompanypage/${row.original.nsCompanyId}`}>
                {value}
            </Link>
        ),
    },
    {
        Header: 'Company Domain',
        accessor: 'companyDomains',
        className: generalStyles.tableCell,
        Filter: MultiSelectColumnFilter,
        filter: FILTER_TYPES.multiple,
        Cell: ({ row, value }) => (
            <Link className={generalStyles.link} to={`/newcompanypage/${row.original.nsCompanyId}`}>
                {value}
            </Link>
        ),
    },
    {
        Header: 'Matched Accounts',
        accessor: (row) => row.matchedAccounts?.join(', ') ?? '',
        id: 'matchedAccounts',
        className: generalStyles.tableCell,
    },
    {
        Header: 'Invited Date',
        accessor: (row) => new Date(row.invitedDtm).toLocaleDateString(),
        id: 'invitedDtm',
        className: generalStyles.tableCell,
        Filter: DateRangeColumnFilter,
        filter: FILTER_TYPES.dateRange,
    },
    {
        Header: 'Invite Source',
        accessor: 'invitationSource',
        className: generalStyles.tableCell,
        Filter: MultiSelectColumnFilter,
        filter: FILTER_TYPES.multiple,
    },
    {
        Header: 'Invitation Approval Status',
        accessor: 'invitationApprovalStatus',
        className: generalStyles.tableCell,
        Filter: MultiSelectColumnFilter,
        filter: FILTER_TYPES.multiple,
    },
    {
        Header: 'Request Details',
        accessor: 'requestDetails',
        className: generalStyles.tableCell,
    },
    {
        Header: 'Flag',
        accessor: 'approvalNeededReasonCode',
        className: generalStyles.tableCell,
    },
]

